/* eslint-disable flowtype/require-valid-file-annotation */

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Button from 'material-ui/Button'
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle,
} from 'material-ui/Dialog'
import { Field, reduxForm } from 'redux-form'
import { FormLabel, FormControl, FormControlLabel, FormHelperText } from 'material-ui/Form'
import Input, { InputLabel } from 'material-ui/Input'
import LoadingIndicator from '../components/loadingIndicator'
import { MenuItem } from 'material-ui/Menu'
import Messages from '../constants/messages'
import Radio, { RadioGroup } from 'material-ui/Radio'
import Select from 'material-ui/Select'
import withStyles from 'material-ui/styles/withStyles'


const PROP_TYPES = {
  buttonLabel:PropTypes.string,
  clientList:PropTypes.array,
  confirmationItem: PropTypes.object,
  confirmationFieldData: PropTypes.object,
  data: PropTypes.object,
  dialogOptions: PropTypes.array.isRequired,
  isLoading:PropTypes.bool.isRequired,
  lookUpValue: PropTypes.string,
  lookUpFunc: PropTypes.func,
  showDialog:PropTypes.func.isRequired,
  resetFormValues:PropTypes.func.isRequired,
  permissions:PropTypes.array,
  open:PropTypes.bool.isRequired,
  title:PropTypes.string.isRequired,
}

const styles = theme => ({
  root: {
    float: 'right',
    marginBottom: 15
  },
  btn: {
    textAlign: 'right'
  },
  portalContainer: {
    overflow: "scroll"
  },
  field: {
    marginBottom: 15
  },
  fieldContainer: {
    display: "flex",
    "justify-content": "center",
    "flex-direction": "column"
  },
  formControl: {
    marginTop: theme.spacing.unit * 2,
  },
  notSelected: {
    backgroundColor: "none", //Overides for deselecting in multiselect menuItems
    '&:focus': {
      background: "none",
    }
  }
})

let timeout = null

export class FormDialog extends Component {

  handleChange = fieldName => event => {
    this.props.handleFormValueChange({fieldName, value: event.target.value})
  }

  handleChangeWithFetch = (fieldName, action) => event => {
    action(event.target.value)
    this.props.handleFormValueChange({fieldName, value: event.target.value})
  }

  delayFunction = (delayedFunction, delay) => {
    // this checks for any keystrokes and will not fire the lookupFunc until there is > {delay} between keystrokes
    timeout = setTimeout(() => {
        delayedFunction()
    }, delay)
  }

  renderButton() {
    const { classes, showDialog, buttonLabel } = this.props
    let markup = null
    if (buttonLabel) {
      markup = (
        <div className={classes.btn}>
          <Button raised color="primary" onClick={() => showDialog(true, 'new')} id="formDialogBtn">
            {buttonLabel}
          </Button>
        </div>
      )
    }
    return markup
  }

  renderDialog() {
    const {
      classes,
      infoText,
      isLoading,
      showDialog,
      handleSubmit,
      handleFormSubmit,
      open,
      resetFormValues,
      title } = this.props

    return (
        <Dialog
          id="formDialog"
          open={open}
          onRequestClose={() => {
            showDialog(false)
            resetFormValues()
          }}
          fullWidth={true}>
            <div className={`${classes.portalContainer} portalContainer`}>
              <DialogTitle>{title}</DialogTitle>
              <form onSubmit={ handleSubmit(handleFormSubmit) }>
                <DialogContent>
                  { isLoading ? <LoadingIndicator
                                  infoText={infoText ? infoText : Messages['uiComponents']['LOADING_MSG']}
                                  isDialog={true}/> : this.renderFields() }
                </DialogContent>
                <DialogActions>
                  <Button
                    disabled={isLoading}
                    onClick={() => {
                      showDialog(false)
                      resetFormValues()
                    }}
                    id="cancelBtn"
                    color="primary">
                      {Messages['uiComponents']['FORM_DIALOG_CANCEL_BUTTON_LABEL']}
                  </Button>
                  <Button disabled={isLoading} type="submit" color="primary" id="submitBtn">
                    {Messages['uiComponents']['FORM_DIALOG_SUBMIT_BUTTON_LABEL']}
                  </Button>
                </DialogActions>
              </form>
            </div>
        </Dialog>
    )
  }

  renderTextField(props) {
    const {
      helperText,
      input,
      label,
      meta: {
        touched,
        error
      },
      name,
      type
    } = props
    return (
      <div className="form-field">
        <FormControl fullWidth={true} error={touched && error}>
          <InputLabel htmlFor={name}>{label}</InputLabel>
          <Input
            id={name}
            className="input-field"
            {...input}
            type={type} />
          <FormHelperText>{touched && error ? error : helperText}</FormHelperText>
        </FormControl>
      </div>
    )
  }

  renderLookUpTextField(props) {
    const {
      input,
      label,
      resetFormValue,
      resetLookUpValue,
      lookUpFunc,
      delayFunction,
      meta: {
        touched,
        error
      },
      name,
      type
    } = props
    return (
      <div className="form-field">
        <FormControl fullWidth={true} error={touched && error}>
          <InputLabel htmlFor={name}>{label}</InputLabel>
          <Input
            id={name}
            className="input-field"
            {...input}
            type={type}
            onChange={(param) => {
              let value = param.target.value
              input.onChange(value)
              resetFormValue('dialogValues', 'groupIds', '')

              if(value.toString().length > 2) { // don't fire fetch if single digit partnerId
                clearTimeout(timeout)
                delayFunction(() => {
                  resetLookUpValue()
                  lookUpFunc({id: value}, true)
                }, 1500)
              } else { // if user removes partnerId, clear lookUpValue
                clearTimeout(timeout)
                delayFunction(() => {
                  resetLookUpValue()
                }, 1500)
              }
              }
            } />
          <FormHelperText>{touched && error ? error : ''}</FormHelperText>
        </FormControl>
      </div>
    )
  }

  renderPartnerDropdownDisabled(props){
    const {
      helperText,
      input,
      meta: {
        touched,
        error
      }} = props
    return (
      <div className="form-field">
        <FormControl fullWidth={true} error={touched && error} disabled={true}>
          <InputLabel >{'Partner Name'}</InputLabel>
          <Select
            {...input}
            className="input-field"
            value={helperText}>
            <MenuItem selected={true} value={helperText}>
              <em>{helperText}</em>
            </MenuItem>
          </Select>
        <FormHelperText></FormHelperText>
        </FormControl>
      </div>
    )
  }

  renderPartnerDropdown(props) {
    const {
      partnerList,
      resetFormValue,
      helperText,
      input,
      label,
      lookUpFunc,
      multiple,
      meta: {
        touched,
        error
      }} = props

    return (
      <FormControl error={touched && error}>
        <InputLabel>{label}</InputLabel>
        <Select
          data-test-id='partnerSelectField'
          {...input}
          multiple={multiple}
          value={input.value ? input.value : {}}
          onChange={param => {
            let value = param.target.value
            resetFormValue('dialogValues', 'groupIds', '')
            input.onChange(value)
            let partner = value ? JSON.parse(value) : {}
            lookUpFunc(partner, true)
          }}>
            <MenuItem disabled value="">
              <em>None</em>
            </MenuItem>
            {partnerList && partnerList.map(partner => (
              <MenuItem key={partner.id} value={JSON.stringify({id:partner.id, name:partner.name})}>
                {partner.name}
              </MenuItem>
            ))}
        </Select>
        <FormHelperText>{touched && error ? error : helperText}</FormHelperText>
      </FormControl>
    )
  }

  renderGroupDropdown(props) {
    const {
      disabled,
      groups,
      input,
      label,
      meta: {
        touched,
        error
      }} = props

    return (
      <FormControl error={touched && error} disabled={disabled}>
        <InputLabel>{label}</InputLabel>
        <Select
          data-test-id="groupSelectField"
          {...input}
          multiple
          value={input.value ? input.value : []}
          onChange={param => input.onChange(param.target.value)}>
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {groups && groups.map(group => (
              <MenuItem key={group.id} value={group.id}>
                {group.name}
              </MenuItem>
            ))}
        </Select>
        <FormHelperText>{touched && error ? error : ''}</FormHelperText>
      </FormControl>
    )
  }

  renderRoleDropdown(props) {
    const {
      classes,
      roles,
      input,
      label,
      meta: {
        touched,
        error
      }} = props

    const selectedClass = (id) =>  {
      return Array.isArray(input.value) && input.value.indexOf(id) === -1 ?
      classes.notSelected : null
    }

    return (
      <FormControl error={touched && error}>
        <InputLabel>{label}</InputLabel>
        <Select
          data-test-id='roleSelectField'
          {...input}
          multiple
          value={input.value ? input.value : []}
          onChange={param => input.onChange(param.target.value)}>
            <MenuItem value="" disabled>
              <em>None</em>
            </MenuItem>
            {roles && roles.map(role => (
              <MenuItem key={role.id} value={role.id} className={selectedClass(role.id)}>
                {role.name}
              </MenuItem>
            ))}
        </Select>
        <FormHelperText>{touched && error ? error : ''}</FormHelperText>
      </FormControl>
    )
  }

  renderAppSelectField(props) {
    const {
      clientList,
      helperText,
      input,
      label,
      meta: {
        touched,
        error
      }} = props
    let isEdit = false
    if (input.value.type) {
      input.value = input.value.id
      isEdit = true //If editing, want to disable ability to change application
    }
    return (
      <FormControl error={touched && error} disabled={isEdit}>
        <InputLabel htmlFor="appId">{label}</InputLabel>
        <Select
          data-test-id='appSelectField'
          {...input}
          onChange={param => input.onChange(param.target.value)}>
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {clientList.map(client => (
            <MenuItem key={client.id} value={client.id}>
              {client.name}
            </MenuItem>
          ))}
        </Select>
        <FormHelperText>{touched && error ? error : helperText}</FormHelperText>
      </FormControl>
    )
  }

  renderRolesRadioGroup(props) {
    const { classes, input } = props

    return (
      <FormControl component="fieldset" className={classes.formControl}>
        <FormLabel component="legend">Role</FormLabel>
        <RadioGroup
          aria-label="role"
          name="role1"
          value={input.value || 'user'}
          onChange={param => input.onChange(param.target.value)}>
          <FormControlLabel
            value="admin"
            control={<Radio />}
            label={Messages['uiComponents']['ADMIN_RADIO']} />
          <FormControlLabel
            value="user"
            control={<Radio />}
            label={Messages['uiComponents']['USER_RADIO']} />
        </RadioGroup>
      </FormControl>
    )
  }

  renderUserSelectField(props) {
    const {
      groupUsers,
      helperText,
      input,
      label,
      userList,
      meta: {
        touched,
        error
      }} = props

    return (
      <FormControl error={touched && error}>
        <InputLabel htmlFor="applicationId">{label}</InputLabel>
        <Select
          data-test-id='userSelectField'
          {...input}
          onChange={param => input.onChange(param.target.value)}>
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {
            groupUsers ? userList.filter(user => {
              return !groupUsers.some(groupUser => {
                return groupUser.id ? groupUser.id === user.id : groupUser === user.id
              })
            }).map(user => (
              <MenuItem key={user.id} value={user.id}>
                {user.email}
              </MenuItem>
            )) :
            null
        }
        </Select>
        <FormHelperText>{touched && error ? error : helperText}</FormHelperText>
      </FormControl>
    )
  }

  renderAppSelectFieldFetch(props){

    const {
      clientList,
      fetchAction,
      helperText,
      input,
      meta: {
        touched,
        error,
        initial
      },
      permissions } = props
    if (input.value && permissions.length === 0) {
      fetchAction(input.value)
    }
    let isEdit = initial //disable ability to change app if editing
    return (
      <FormControl error={touched && error} disabled={isEdit}>
        <InputLabel htmlFor="appSelectFieldFetch">Application</InputLabel>
        <Select
          data-test-id='appSelectFieldFetch'
          {...input}
          onChange={param => {
            input.onChange(param.target.value)
            fetchAction(param.target.value)
          }}
          input={<Input id="appSelectFieldFetch" />}>
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {clientList.map(client => (
            <MenuItem key={client.id} value={client.id}>
              {client.name}
            </MenuItem>
          ))}
        </Select>
        <FormHelperText>{touched && error ? error : helperText}</FormHelperText>
      </FormControl>
    )
  }

  renderPermissionMultiSelectField(props) {
    const {
      classes,
      helperText,
      input,
      permissionList,
      meta: {
        touched,
        error
      }} = props
    const selectedClass = (id) =>  {
      return Array.isArray(input.value) && input.value.indexOf(id) === -1 ?
      classes.notSelected : null
    }
    return (
      <FormControl error={touched && error}>
        <InputLabel htmlFor="permissionIds">
          {
            permissionList && permissionList.length < 1 ? Messages['uiComponents']['NO_PERMISSION_SELECT_FIELD'] : 'Permissions'
          }
        </InputLabel>
        <Select
          data-test-id='permissionSelectField'
          {...input}
          multiple
          value={input.value ? input.value : []}
          disabled={permissionList && permissionList.length < 1 ? true : false}
          onChange={param => input.onChange(param.target.value)}
          input={<Input id="permissionIds" />}>
          <MenuItem disabled className={selectedClass('')}>
            <em>None</em>
          </MenuItem>
          { permissionList ?
              permissionList.map(permission => (
                <MenuItem key={permission.id} value={permission.id} className={selectedClass(permission.id)}>
                  {permission.name}
                </MenuItem>
              )
            ) : null
          }
        </Select>
        <FormHelperText>{touched && error ? error : helperText}</FormHelperText>
      </FormControl>
    )
  }

  renderConfirmation(props) {
    const { confirmationItem, confirmationType, confirmationFieldData } = props
    switch (confirmationType) {
      case 'delete':
        const { name, fullName, email } = confirmationItem
        return <p>{Messages['confirmations']['DELETE_USER_MSG']}<b>{name || (fullName === Messages['confirmations']['PENDING_USER_NAME'] ? email : fullName)}</b>?</p>
      case 'forgotPassword':
        return <p>{Messages['confirmations']['RESET_PASSWORD_MSG1']}<b>{confirmationItem.email}</b>{Messages['confirmations']['RESET_PASSWORD_MSG2']}</p>
      case 'resendVerification':
        return <p>{Messages['confirmations']['RESEND_VERIFY_EMAIL_MSG']}<b>{confirmationItem.email}</b>?</p>
      case 'removeFromGroup':
        return <p>{Messages['confirmations']['REMOVE_USER_FROM_GROUP_MGS']}<b>{confirmationFieldData.userName}</b> from <b>{confirmationFieldData.groupName}</b>?</p>
      default:
    }
  }


  renderFields() {
    const { confirmationItem,
      confirmationFieldData,
      classes,
      data,
      dialogOptions,
      initialValues,
      isLoadingPartnerFilteredGroups,
      lookUpFunc,
      lookUpValue,
      resetFormValue,
      resetLookUpValue } = this.props

    let markup = null
    if (dialogOptions) {
      markup = (
        <div className={classes.fieldContainer}>
          {
            dialogOptions.map((dialogField, index) => {
              switch (dialogField.type) {
                case 'textField':
                  return (
                    <Field
                      classes={classes}
                      name={dialogField.name}
                      key={index}
                      label={dialogField.friendlyName}
                      component={this.renderTextField}
                      multiline={dialogField.multiline}
                      validate={dialogField.validationRules} />
                  )
                case 'appSelectField':
                  return (
                    <Field
                      classes={classes}
                      clientList={data.clientList}
                      name={dialogField.name}
                      key={index}
                      label={dialogField.friendlyName}
                      component={this.renderAppSelectField}
                      validate={dialogField.validationRules} />
                  )
                case 'appSelectFieldFetch':
                  return (
                    <Field
                      classes={classes}
                      permissions={data.permissions}
                      clientList={data.clientList}
                      name={dialogField.name}
                      key={index}
                      component={this.renderAppSelectFieldFetch}
                      validate={dialogField.validationRules} />
                  )
                case 'permissionMultiSelectField':
                  return (
                    <Field
                      appId={data.appId}
                      classes={classes}
                      name={dialogField.name}
                      permissionList={data.permissions}
                      permissions={dialogField.name}
                      key={index}
                      component={this.renderPermissionMultiSelectField}
                      validate={dialogField.validationRules} />
                  )
                case 'userSelectField':
                  return (
                    <Field
                      classes={classes}
                      userList={data.userList}
                      groupUsers={initialValues.users}
                      name={dialogField.name}
                      key={index}
                      label={dialogField.friendlyName}
                      component={this.renderUserSelectField}
                      validate={dialogField.validationRules} />
                  )
                case 'confirmation':
                  return (
                    <Field
                      classes={classes}
                      name={dialogField.name}
                      confirmationItem={confirmationItem}
                      confirmationType={dialogField.confirmationType}
                      confirmationFieldData={confirmationFieldData}
                      key={index}
                      component={this.renderConfirmation} />
                  )
                case 'rolesRadioGroup':
                  return (
                    <Field
                      classes={classes}
                      name={dialogField.name}
                      key={index}
                      component={this.renderRolesRadioGroup} />
                  )
                case 'partnerManualLookup':
                  if (!lookUpValue) {
                    return (
                      <Field
                        classes={classes}
                        name={dialogField.name}
                        key={index}
                        label={dialogField.friendlyName}
                        resetFormValue={resetFormValue}
                        resetLookUpValue={resetLookUpValue}
                        component={this.renderLookUpTextField}
                        lookUpFunc={lookUpFunc}
                        delayFunction={this.delayFunction}
                        validate={dialogField.validationRules} />
                    )
                  } else {
                    return (
                      <div className={'form-field'} key={index}>
                        <Field
                          classes={classes}
                          name={dialogField.name}
                          label={dialogField.friendlyName}
                          resetFormValue={resetFormValue}
                          resetLookUpValue={resetLookUpValue}
                          component={this.renderLookUpTextField}
                          lookUpFunc={lookUpFunc}
                          delayFunction={this.delayFunction}
                          validate={dialogField.validationRules} />
                        <Field
                          classes={classes}
                          helperText={lookUpValue}
                          name={''}
                          label={dialogField.friendlyName}
                          component={this.renderPartnerDropdownDisabled}
                          value={lookUpValue}
                          validate={dialogField.validationRules} />
                      </div>
                    )
                  }
                case 'partnerDropdown':
                  return (
                    <Field
                      classes={classes}
                      name={dialogField.name}
                      label={dialogField.friendlyName}
                      lookUpFunc={lookUpFunc}
                      partnerList={data.partnerList}
                      resetFormValue={resetFormValue}
                      key={index}
                      multiple={(typeof dialogField.multiple !== 'undefined') ? dialogField.multiple : true}
                      component={this.renderPartnerDropdown}
                      validate={dialogField.validationRules} />
                  )
                case 'groupDropdown':
                  let label, disabled

                  switch (true) {
                    case !lookUpValue:
                      label = Messages['uiComponents']['NO_VALID_PARTNER_ID']
                      disabled = true
                      break
                    case lookUpValue === 'loading...':
                    case isLoadingPartnerFilteredGroups:
                      label = Messages['uiComponents']['LOADING_MSG']
                      disabled = true
                      break
                    case data.groups.length < 1:
                      label = Messages['uiComponents']['NO_GROUPS_ASSOSCIATED_WITH_PARTNER']
                      disabled = true
                      break
                    default:
                      label = dialogField.friendlyName
                      disabled = false
                      break
                  }

                  return (
                    <Field
                      classes={classes}
                      disabled={disabled}
                      name={dialogField.name}
                      label={label}
                      groups={data.groups}
                      key={index}
                      component={this.renderGroupDropdown}
                      validate={dialogField.validationRules} />
                  )
                case 'groupDropdownPartnerAdmin':
                  let groupDropdownPALabel, groupDropdownPADisabled

                  switch (true) {
                    case isLoadingPartnerFilteredGroups:
                      groupDropdownPALabel = Messages['uiComponents']['LOADING_MSG']
                      groupDropdownPADisabled = true
                      break
                    case data.groups.length < 1:
                      groupDropdownPALabel = Messages['uiComponents']['PA_DROPDOWN_NO_GROUPS']
                      groupDropdownPADisabled = true
                      break
                    default:
                      groupDropdownPALabel = dialogField.friendlyName
                      groupDropdownPADisabled = false
                      break
                  }
                  return (
                    <Field
                      classes={classes}
                      disabled={groupDropdownPADisabled}
                      name={dialogField.name}
                      label={groupDropdownPALabel}
                      groups={data.groups}
                      key={index}
                      component={this.renderGroupDropdown}
                      validate={dialogField.validationRules} />
                  )
                case 'roleDropdown':
                  return (
                    <Field
                      classes={classes}
                      name={dialogField.name}
                      label={dialogField.friendlyName}
                      roles={data.rolesList}
                      key={index}
                      component={this.renderRoleDropdown}
                      validate={dialogField.validationRules} />
                  )
                default:
                  return null
              }
            })
          }
        </div>
      )
    }
    return markup
  }

  render() {
    const { classes } = this.props

    return (
      <div className={classes.root}>
        {this.renderButton()}
        {this.renderDialog()}
      </div>
    )
  }
}

FormDialog.propTypes = PROP_TYPES
FormDialog = reduxForm({
  form: 'dialogValues',
  // known issue with dynamic Fields and validations,
  // below is a workaround to solve issue of it not validating
  // https://github.com/erikras/redux-form/issues/3276
  shouldValidate: () => true
})(FormDialog)

export default withStyles(styles)(FormDialog)
